module.exports = {
	"name": "Amsterdam",
	"slug": "amsterdam",
	"description": "Amsterdam is known for making people feel gezellig, a Dutch quality that translates roughly as convivial or cosy. You can feel gezellig in many situations, especially when sipping a fresh mint tea in a cafe near the historical canals or enjoying the city’s international cuisine.",
	"hotspots": [
		{
			"name": "Bar Botanique",
			"description": "Once known as De Ponteneur, the Bar Botanique adds a bring of fresh to the restaurant scene in Amsterdam. The large windows and colorful inside invite the visitors to stay in the cozy velvet chairs from early mornings to late in the evening. Visitors can choose from a very extensive menu that offers from burgers to salads, something for everybody! Choose where to sit, either in the tropical bar section, in the salmon-colored dining area or, if the weather allows it, outside in front of the bar.",
			"url": "http://www.barbotanique.nl/nl/menu.html",
			"lat": 52.363409,
			"long": 4.930237,
			"type": "drink"
		},
		{
			"name": "Amsterdam Tower",
			"description": "This 22 story-high building is an observation deck with an incredible panoramic view of the whole city, going from the historical center to the famous canals. For those looking for some adrenaline-pumping activity, the ‘Over the Edge’ swing is the highest in Europe, inviting its visitors to go back and forth over the edge of the tower with Amsterdam 100 meters below their feet.",
			"url": "https://www.adamlookout.com/",
			"lat": 52.3839167,
			"long": 4.893342,
			"type": "sightseeing"
		},
		{
			"name": "Foodhallen",
			"description": "The Foodhallen is one of the trendiest spots in Amsterdam. Ideal place to grab a relaxed meal, snack of a drink with friends, this industrial yet friendly place is lined with many different street food vendors, from pizzas to dim sum. Grab a bite then go catch a movie in the Filmhallen next door, enjoy!",
			"url": "http://foodhallen.nl/",
			"lat": 52.3670625,
			"long": 4.8658894,
			"type": "food"
		},
		{
			"name": "Winkel 43",
			"description": "The best apple pie in Amsterdam. Period. Winkel 43 is a cosy cafe loved by both tourists and locals. During the cold days you can sit inside with a warm glass of fresh mint tea and indulge with a piece of apple pie (with cream? Yes please!), during sunny days you can enjoy the terrace and the view: the busy crowd walking around the Noordermarkt.",
			"url": "http://www.winkel43.nl/",
			"lat": 52.3790661,
			"long": 4.8840322,
			"type": "food"
		},
		{
			"name": "Tiny Little Secret",
			"description": "The city of Amsterdam is a beautiful one, but there is more than just the canals. Take a camera and look for the hidden secrets! On the Westerstraat in Amsterdam the house numbers numbers between 54 and 70 are missing… an error that has been corrected by constructing 7 mini houses in the small four-inch crack.",
			"url": "https://www.google.nl/maps/place/Westerstraat+54I,+1015+ML+Amsterdam/data=!4m2!3m1!1s0x47c609cfeeb5e409:0xe8bdc2bbf9fd06e6?sa=X&ved=0ahUKEwj08Oa63uzRAhUDDxoKHc3GBwgQ8gEIGzAA",
			"lat": 52.378763,
			"long": 4.884536,
			"type": "sightseeing"
		},
		{
			"name": "Foam",
			"description": "The internationally renowned photography museum invites the visitors to discover all genres of photography, displaying a wide variety of works. Since its opening in 2002, the museum has dared to push the boundaries, not being afraid of confrontation. The Foam has showcased some of the biggest names in the field but has also given an opportunity to rising talents, reaching young and old, local and international, amateurs and experts.",
			"url": "https://www.foam.org/",
			"lat": 52.3640863,
			"long": 4.8933224,
			"type": "gallery"
		}
	],
	"cities": [
		{
			"name": "berlin",
			"img": "/media/img/cities/berlin_thumb.jpg",
			"url": "/city/berlin"
		},
		{
			"name": "london",
			"img": "/media/img/cities/london_thumb.jpg",
			"url": "/city/london"
		}
	],
	"media": [
		"/media/img/cities/amsterdam/amsterdam_slider-5.jpg",
		"/media/img/cities/amsterdam/amsterdam_slider-1.jpg",
		"/media/img/cities/amsterdam/amsterdam_slider-3.jpg",
		"/media/img/cities/amsterdam/amsterdam_slider-2.jpg",
		"/media/img/cities/amsterdam/amsterdam_slider-4.jpg",
		"/media/img/cities/amsterdam/amsterdam_slider-6.jpg"
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/cities/amsterdam.json
// module id = 70
// module chunks = 0